import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    dot: {
      '& text': {
        color: '#000',
        fontWeight: 400,
        fontSize: 14,
      },
    },
  })
)

export default useStyles
